export const MARKET_API_KEY = "coinranking94fe84488a5fed84619deabeac12ebecb5f5beb669226683";
export const API_KEY = '38ded07070850470f75a8cd89e0124a8fa85aa692971a57493f82b957cf672d3';